import { render, staticRenderFns } from "./FundManagementFormTab.vue?vue&type=template&id=6db3cf68&"
import script from "./FundManagementFormTab.vue?vue&type=script&lang=js&"
export * from "./FundManagementFormTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports